<template>
	<div class="relative">
		<div class="overflow-y-auto max-h-full w-full md:w-2/5 xl:w-1/3 absolute">
			<thread-search-input :filter="filter" :showSearch="showSearch" />
		</div>
		<div
			class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow flex flex-col space-y-2"
		>
			<div
				class="flex-grow flex flex-col justify-center border-2 border-gray-300 border-dashed rounded-lg p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
			>
				<ui-icon
					class="mx-auto h-18 w-18 text-gray-400"
					name="message-square"
					stroke-width="1"
				/>
				<p class="mt-2 text-2xl text-gray-400 font-medium">
					<span v-if="locale == 'de'">
						<h1>
							Keine Ergebnisse für Verhandlungen im Status "{{
								__(
									$cropOptions.getLabel(
										filterStatus,
										$cropOptions.threadStatusOptions
									)
								)
							}}"
						</h1>
					</span>
					<span v-else>
						<h1>
							No results for negotiations with status "{{
								__(
									$cropOptions.getLabel(
										filterStatus,
										$cropOptions.threadStatusOptions
									)
								)
							}}"
						</h1>
					</span>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		filterStatus: {
			type: String,
			default: "UNDER_NEGOTIATION",
		},
		filter: {
			type: Object,
			required: true,
		},
		showSearch: {
			type: Boolean,
			required: false,
		},
	},
};
</script>
